import { Routes } from '@angular/router';
import { roleCanMatch, roleCanActivate } from './core/guards/role.guard';


export const routes: Routes = [
  {
    path: "",
    redirectTo: "/login",
    pathMatch: "full",
  },
  {
    path: "privacy",
    loadChildren: () =>
      import("./modules/privacy/privacy.module").then((m) => m.PrivacyModule),
  },
  {
    path: "support",
    loadChildren: () =>
      import("./modules/support/support.module").then((m) => m.SupportModule),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./modules/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "hub",
    loadChildren: () =>
      import("./modules/hub/hub.module").then((m) => m.HubModule),
  },
  {
    path: "gerencia",
    loadChildren: () =>
      import('./modules/gerencia/gerencia.module').then(m => m.GerenciaModule),
    canMatch: [roleCanMatch],
    data: { expectedRoles: ["gerencia"] },
  },
  {
    path: "admin",
    loadChildren: () =>
      import('./modules/admin/admin.module').then(m => m.AdminModule),
    canMatch: [roleCanMatch],
    data: { expectedRoles: ["admin", "asistencia"] },
  },
  {
    path: "administrativos",
    loadChildren: () =>
      import('./modules/administrativos/administrativos.module').then(m => m.AdministrativosModule),
    canMatch: [roleCanMatch],
    data: { expectedRoles: ["administrativos"] },
  },
  {
    path: "seguridad",
    loadChildren: () =>
      import('./modules/seguridad/seguridad.module').then(m => m.SeguridadModule),
    canMatch: [roleCanMatch],
    data: { expectedRoles: ["seguridad"] },
  },
  {
    path: "rrhh",
    loadChildren: () =>
      import('./modules/rrhh/rrhh.module').then(m => m.RrhhModule),
    canMatch: [roleCanMatch],
    data: { expectedRoles: ["admin", "rrhh"] },
  },
  {
    path: "qhse-asistencia",
    loadChildren: () =>
      import('./modules/qhse-asistencia/qhse-asistencia.module').then(m => m.QhseAsistenciaModule),
  }
];
